import { OnboardingConfigDTO, OnboardingModuleEnum } from "front-lib";

export const categoriesOnboarding: OnboardingConfigDTO = {
    module: OnboardingModuleEnum.SETTINGS_CATEGORIES,
    steps: [
        {
            id: "cat-welcome",
            title: "Categorias de Serviço",
            description:
                "Configure as categorias de corrida disponíveis (ex: Econômico, Conforto, Premium) e suas respectivas tarifas.",
            position: "center",
        },
        {
            id: "cat-list",
            title: "Lista de Categorias",
            description:
                "Veja as categorias existentes com nome, tarifa base e status. Clique para editar qualquer uma.",
            targetId: "categories-list",
            position: "bottom",
        },
        {
            id: "cat-add",
            title: "Criar Categoria",
            description:
                "Adicione uma nova categoria definindo nome, ícone, tarifa por km, por minuto e taxa base.",
            targetId: "categories-add-btn",
            position: "left",
        },
        {
            id: "cat-pricing",
            title: "Configuração de Preços",
            description:
                "Em cada categoria, defina a tarifa base, preço por km, preço por minuto, cancelamento e tarifa mínima.",
            position: "center",
        },
    ],
};
